import { Form, Input, Button } from "antd";
import { useLanguage } from "~/hooks/useLanguage";
import { useChangePassword } from "./hooks/useChangePassword";
import { ChangePasswordInput } from "./types/changePassword";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { UpdateExpiredPasswordInput } from "../expiredPassword/types/updateExpiredPassword";
import { useNavigate } from "react-router-dom";
import { PAGE_LOGIN } from "~/constants/page";
import { FC } from "react";
import { useExpiredPassword } from "../expiredPassword/hooks/useExpiredPassword";
interface ChangePasswordProps {
  isExpiredPasswordChange?: boolean;
  onClose?: () => void;
}

const ChangePassword: FC<ChangePasswordProps> = ({
  isExpiredPasswordChange,
  onClose,
}) => {
  const { formatMessage } = useLanguage();
  const [form] = Form.useForm();
  const { updateExpiredPassword } = useExpiredPassword();
  const { changePassword, loading } = useChangePassword();

  const { handleRemoveToken, username } = useAuthenticationContext();
  const navigate = useNavigate();

  const handleSubmit = async (values: ChangePasswordInput) => {
    if (isExpiredPasswordChange && username) {
      const input: UpdateExpiredPasswordInput = {
        username,
        password: values.password,
        newPassword: values.newPassword,
      };
      const result = await updateExpiredPassword(input);
      if (result) {
        form.resetFields();
        handleRemoveToken();
        navigate(PAGE_LOGIN);
      }
    } else {
      const result = await changePassword(values);
      if (result) {
        form.resetFields();
        onClose?.();
        //INFO, Fatih, wait 1.5 seconds to display success notification
        setTimeout(() => {
          handleRemoveToken();
        }, 1500);
      }
    }
  };

  return (
    <div>
      <Form
        form={form}
        name="changePassword"
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600, marginTop: 24 }}
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="password"
          label={formatMessage("ChangePassword.Label.CurrentPassword")}
          rules={[
            {
              required: true,
              message: formatMessage(
                "ChangePassword.Validation.RequiredCurrentPassword",
              ),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label={formatMessage("ChangePassword.Label.NewPassword")}
          rules={[
            {
              required: true,
              message: formatMessage(
                "ChangePassword.Validation.RequiredNewPassword",
              ),
            },
            {
              min: 8,
              message: formatMessage(
                "ChangePassword.Validation.PasswordLength",
              ),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={formatMessage("ChangePassword.Label.ConfirmPassword")}
          dependencies={["newPassword"]}
          rules={[
            {
              required: true,
              message: formatMessage(
                "ChangePassword.Validation.RequiredConfirmPassword",
              ),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    formatMessage(
                      "ChangePassword.Validation.PasswordsDoNotMatch",
                    ),
                  ),
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 16, span: 8 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {formatMessage("ChangePassword.Label.ChangePassword")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
